// Appointment location picker (`_appointment_schedule_fields.html`).
// `show-when` owns the Property Address / Other Location / Online switch and disables the
// inactive location input. Selected Places render as a list item, while the
// original input still posts the full location for calendars and activity logs.
(function () {
    function init(root) {
        if (root.dataset.appointmentLocationReady) return;
        root.dataset.appointmentLocationReady = '1';

        const input = root.querySelector('[data-appointment-location-input]');
        const detailsInput = root.querySelector('[data-appointment-location-details]');
        const search = root.querySelector('[data-appointment-location-search]');
        const selected = root.querySelector('[data-appointment-location-selected]');
        const title = root.querySelector('[data-appointment-location-title]');
        const street = root.querySelector('[data-appointment-location-street]');
        const locality = root.querySelector('[data-appointment-location-locality]');
        const searchClear = search.querySelector('[data-appointment-location-clear]');
        const change = selected.querySelector('[data-appointment-location-change]');
        let details;
        try {
            details = JSON.parse(detailsInput.value || '{}');
        } catch (error) {
            if (!(error instanceof SyntaxError)) throw error;
            // A refused POST can contain malformed metadata. Keep its text editable.
            details = {};
        }

        function render() {
            const hasSelection = details && details.location === input.value
                && typeof details.address === 'string' && details.address
                && typeof details.name === 'string' && typeof details.locality === 'string';
            search.hidden = !!hasSelection;
            selected.hidden = !hasSelection;
            searchClear.hidden = !input.value;
            if (!hasSelection) return;
            title.textContent = details.name || details.address;
            street.textContent = details.name ? details.address : '';
            street.hidden = !details.name;
            locality.textContent = details.locality;
            locality.hidden = !details.locality;
        }

        input.addEventListener('input', () => {
            details = {};
            detailsInput.value = '{}';
            render();
        });
        change.addEventListener('click', () => {
            selected.hidden = true;
            search.hidden = false;
            input.focus();
            input.select();
        });
        root.querySelectorAll('[data-appointment-location-clear]').forEach((clear) => {
            clear.addEventListener('click', () => {
                input.value = '';
                input.dispatchEvent(new Event('input', { bubbles: true }));
                input.focus();
            });
        });
        render();

        if (!window.SeeMe || !SeeMe.placesTypeahead) return;
        SeeMe.placesTypeahead.attach(input, {
            apiKey: root.dataset.placesApiKey,
            unitFallback: false,
            onSelect(result) {
                if (input.disabled) return;
                const isVenue = result.types.some((type) => type === 'establishment' || type === 'point_of_interest');
                const address = result.formattedAddress || result.description;
                input.value = isVenue && result.displayName && address
                    ? `${result.displayName}, ${address}`
                    : address || result.displayName || input.value;
                input.dispatchEvent(new Event('input', { bubbles: true }));
                const cityState = [result.city, result.state].filter(Boolean).join(', ');
                details = {
                    location: input.value,
                    name: isVenue ? result.displayName || '' : '',
                    address: result.address || address,
                    locality: result.address ? [cityState, result.zipCode].filter(Boolean).join(' ') : '',
                };
                detailsInput.value = JSON.stringify(details);
                render();
                change.focus();
            },
        });
    }

    function onReady(event) {
        const scope = event && event.target && event.target.querySelectorAll ? event.target : document;
        if (scope.matches && scope.matches('[data-appointment-location-fields]')) init(scope);
        scope.querySelectorAll('[data-appointment-location-fields]').forEach(init);
    }

    document.addEventListener('DOMContentLoaded', () => onReady({ target: document }));
    document.body.addEventListener('sheet:ready', onReady);
    document.body.addEventListener('htmx:afterSettle', onReady);
    document.body.addEventListener('htmx:load', onReady);
}());
